import { uploadImage } from '@cronos-app/api';
import { currentWallet } from '@cronos-app/wallet';
import { useMutation } from '@tanstack/react-query';

import { useIsAuthenticated } from './useIsAuthenticated';

export const useUploadImage = (onSuccess?: (imageUrl: string) => void) => {
  const walletAddress = currentWallet.useAccount() ?? '';
  const isAuthenticated = useIsAuthenticated().data;

  return useMutation(
    ({ file }: { file: File }) => {
      if (!isAuthenticated)
        throw new Error('user is not authenticated when trying upload');
      if (!walletAddress)
        throw new Error('user is not connected when trying upload');
      return uploadImage(walletAddress, file);
    },
    {
      onSuccess,
    },
  );
};
